<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group>

    <el-table :data="wechatTemplates" resource="wechat-templates">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="type_text" label="发送场景/模版ID">
        <template slot-scope="scope">
          {{ scope.row.type_text }}
          <el-tag size="medium">{{ scope.row.template_id }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === true ? 'success' : 'warning'" disable-transitions>{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getWechatTemplates, getSceneTypes } from '@/api/wechat-templates'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'scene_type',
          label: '发送场景',
          type: 'el-select',
          options: [],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'template_id',
          label: '模版ID',
        },
      ],
      wechatTemplates: [],
      page: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getWechatTemplates(newVal.query)
        this.wechatTemplates = data
        this.page = meta
      },
      immediate: true,
    },
  },
  created() {
    this.getSceneTypes()
  },
  methods: {
    async getSceneTypes() {
      const { data } = await getSceneTypes()
      this.search[0].options = data
    },
  },
}
</script>
